import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Link, Snackbar } from "@mui/material";
import { memo } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { StorageKey } from "config/storage";
import { explorerActions, selectShowWeakDeviceMessage } from "slices/explorer";
import { saveToStorage } from "utils/storage";

export default memo(function WeakDeviceSnackbar() {
    const { t } = useTranslation();
    const show = useAppSelector(selectShowWeakDeviceMessage);

    const dispatch = useAppDispatch();

    const dismiss = () => {
        saveToStorage(StorageKey.WeakDeviceMessageDismissed, "true");
        dispatch(explorerActions.setShowWeakDeviceMessage(false));
    };

    const onClose = () => {
        dispatch(explorerActions.setShowWeakDeviceMessage(false));
    };

    if (!show) {
        return null;
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            sx={{
                width: { xs: "auto", sm: 350 },
                bottom: { xs: "auto", sm: 88 },
                top: { xs: 24, sm: "auto" },
                pointerEvents: "auto",
            }}
            open={true}
            onClose={(_, reason) => {
                if (reason === "clickaway") {
                    return;
                }
                onClose();
            }}
            message={
                <Trans i18nKey="weakDeviceMessage">
                    The browser has indicated that you may experience performance issues on this device. Check out
                    <Link
                        href="https://support.novorender.com/en/articles/596748-troubleshooting-guide-for-performance"
                        target="_blank"
                    >
                        support page
                    </Link>
                    if it might be improved.
                </Trans>
            }
            action={
                <Box display="flex" alignItems="center" gap={1}>
                    <Button color="primary" size="small" variant="text" type="button" onClick={dismiss}>
                        {t("doNotShowAgainUppercase")}
                    </Button>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
                        <Close fontSize="small" />
                    </IconButton>
                </Box>
            }
        />
    );
});
